// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"O0-z","sponsoredTooltipWrapper":"P0-z","sponsoredTooltip":"Q0-z","newCard":"R0-z"};